import Buttons from './Buttons';
import Fields from './Fields';
import Layout from './Layout';
import LoadingSpinner from './LoadingSpinner';
import Header from './Header';
import Footer from './Footer';
import SortContainer from './SortContainer';
import FiltersContainer from './FiltersContainer';
import ProductCard from './ProductCard';
import Product from './Product';
import CartTable from './CartTable';
import CategoryBlock from './CategoryBlock';
import YandexMap from './YandexMap';

export default {
  Buttons,
  Fields,
  Layout,
  LoadingSpinner,
  Header,
  Footer,
  SortContainer,
  FiltersContainer,
  ProductCard,
  Product,
  CartTable,
  CategoryBlock,
  YandexMap,
};



// WEBPACK FOOTER //
// ./src/components/ui/index.js